import * as ActionPartnerTypes from 'actions/partner';

const defaultState = {};

export default function accountPlayersCSVReport(state = defaultState, action) {
  switch (action.type) {
    case ActionPartnerTypes.ACCOUNT_PLAYERS_CSV_REPORT_RECEIVE:
      return action.payload;
    default:
      return state;
  }
}
